/**
 * Developed By Aritra Basak, EY
 */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Modal } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { Fade } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import { Divider } from "@mui/material";
import { Typography } from "@material-ui/core";

//Using css by function method.
export const UseStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    padding: 12,
    overflow: "scroll",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  formControl: {
    minWidth: 170,
  },
  button: {
    margin: theme.spacing(1),
    width: "100px ",
    "&:hover": {
      boxShadow: (props) => `0 0 15px ${global.secondaryColour}`,
    },
  },
  noButton: {
    margin: theme.spacing(1),
    width: "100px ",
    "&:hover": {
      boxShadow: (props) => `0 0 15px ${global.secondaryColour}`,
      backgroundColor: "#e6f3ff",
      color: "#f53169d9",
    },
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px solid #000",
  },
}));

function RegisterAbhaV3() {
  const [modalState, setModalState] = React.useState(false);
  const [modalData, setModalData] = React.useState("");
  const modalWidth = Math.min(500, Math.max(300, modalData.length * 6)) + "px";

  useEffect(() => {
    setModalData("Choose the method with which you want to proceed.");
  }, []);

  const handleModalOpen = () => {
    setModalState(true);
  };
  const handleModalClose = () => {
    setModalState(false);
  };

  const classes = UseStyles();
  return (
    <React.Fragment>
      <Grid className="grid-container">
        <Grid item style={{ marginTop: 15 }}>
          <h5>
            <strong>Do you have an ABHA ?</strong>
          </h5>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            style={{
              backgroundColor: global.secondaryColour,
              color: "#fff",
            }}
            component={Link}
            to="/verifyabhav3"
            className={classes.button}
          >
            YES
          </Button>
          {global.isGovtEntity === 1 ? (
            <Button
              variant="contained"
              className={classes.noButton}
              onClick={() => handleModalOpen()}
              style={{
                backgroundColor: "#f53169d9",
                color: "#fff",
              }}
            >
              NO
            </Button>
          ) : (
            <Button
              variant="contained"
              component={Link}
              to="/newabhav3"
              className={classes.button}
              style={{
                backgroundColor: "#f53169d9",
                color: "#fff",
              }}
            >
              NO
            </Button>
          )}
        </Grid>
      </Grid>
      <Modal
        open={modalState}
        onClose={handleModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          onClick: handleModalClose, // This ensures clicking outside the modal closes it
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Fade in={modalState}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // Ensures full viewport height for centering
            }}
            onClick={handleModalClose} // Clicking outside the modal closes it
          >
            <Box
              sx={{
                background: "white",
                display: "flex",
                flexDirection: "column",
                borderRadius: 2,
                p: 3,
                minWidth: "300px",
                maxWidth: "80vw",
                width: modalWidth,
                boxShadow: 24,
              }}
              onClick={(e) => e.stopPropagation()} // Prevents modal close when clicking inside it
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <svg
                  width="25"
                  height="27"
                  viewBox="0 0 128 128"
                  className="me-2"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <style>
                      {`.cls-1{fill:#ffe082}
                  .cls-2{fill:#404040}
                  .cls-3{fill:#9e9e9e}
                  .cls-4{fill:#f5f5f5}`}
                    </style>
                  </defs>
                  <path
                    className="cls-1"
                    d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                  />
                  <path
                    className="cls-2"
                    d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                  />
                  <path
                    className="cls-3"
                    d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                  />
                  <path
                    className="cls-2"
                    d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                  />
                  <line className="cls-4" x1="54" x2="82" y1="102" y2="98" />
                  <path
                    className="cls-2"
                    d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                  />
                  <line className="cls-4" x1="54" x2="82" y1="110" y2="106" />
                  <path
                    className="cls-2"
                    d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                  />
                </svg>
                <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                  Information
                </Typography>
              </Box>

              {/* Decorative Lines */}
              <Divider sx={{ width: "50%", mb: 0.5 }} />
              <Divider sx={{ width: "40%", mb: 2 }} />
              <Typography
                variant="body1"
                sx={{ whiteSpace: "pre-wrap", mb: 2 }}
              >
                {modalData}
              </Typography>
              <div style={{ display: "flex" }}>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: global.secondaryColour,
                    color: "#fff",
                    width: "140px ",
                    textTransform: "none",
                  }}
                  component={Link}
                  to="/newabhav3"
                  className={classes.button}
                >
                  Aadhaar OTP
                </Button>
                <Button
                  variant="contained"
                  component={Link}
                  to="/demoAuthGenerateAbha"
                  className={classes.button}
                  style={{
                    backgroundColor: "#f53169d9",
                    color: "#fff",
                    width: "140px ",
                    textTransform: "none",
                  }}
                >
                  Demographics
                </Button>
              </div>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}

export default RegisterAbhaV3;
